






































































































import Vue from 'vue'
import BookCard from '@/components/BookCard.vue'
import AvailabilityTag from '@/components/AvailabilityTag.vue'
import FlipImageSlide from '@/components/FlipImageSlide.vue'
import Overlay from '@/components/Overlay.vue'
import BorrowForm from '@/components/ModalBorrow.vue'
import { ActionType, GetterType } from '@/store/types'
import { BookListing, BookListingStatus } from '@/types'
import { formatDate, isMobileDevice } from '@/utilities'
export default Vue.extend({
  name: 'BookInfo',
  props: {
    listingId: {
      type: String,
    },
  },
  components: {
    BookCard,
    AvailabilityTag,
    FlipImageSlide,
    Overlay,
    BorrowForm,
  },
  data() {
    return {
      isFullscreen: false,
      isFrontPageActive: true,
      isBookMissing: false,
      isFormVisible: false,
    }
  },
  computed: {
    book(): BookListing {
      return this.$store.getters[GetterType.BOOK](this.listingId)
    },
    isAvailable(): boolean {
      if (this.book == undefined) return false
      return (
        this.book.status == BookListingStatus.AVAILABLE ||
        this.book.status == BookListingStatus.NEW
      )
    },
    isMobile() {
      return isMobileDevice()
    },
    isLoading(): boolean {
      return this.book == undefined
    },
    isWithinPhase(): boolean {
      return this.$store.getters[GetterType.IS_WITHIN_PHASE](new Date())
    },
    phaseStart(): Date | null {
      return this.$store.getters[GetterType.PHASE_START]
    },
    notAvailbleText(): string {
      if (!this.phaseStart)
        return '<em>The current phase for Get Booked! has ended.</em><br /><em>See you in the next one!</em>'
      return `<em>The current phase for Get Booked! has ended.</em><br /><em>The next phase will begin on ${formatDate(
        this.phaseStart,
      )}</em>`
    },
  },

  async created() {
    this.$store.dispatch(ActionType.FETCH_PHASE)
    if (this.$store.getters[GetterType.BOOK](this.listingId) == undefined) {
      this.$store.dispatch(ActionType.FETCH_BOOKS)
    }
    setTimeout(() => {
      this.isBookMissing = true
    }, 5000)
  },
})
